export { default } from "ensure-error";
